import { makePrng } from '@learnforge/demo-math/numeric';

export interface Prng {
  next(): number;
  int(maxExclusive: number): number;
  reset(seed?: number): void;
}

function randomSeed(): number {
  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    const arr = new Uint32Array(1);
    crypto.getRandomValues(arr);
    return arr[0] ?? 1;
  }
  // eslint-disable-next-line no-restricted-properties -- crypto-unavailable fallback; modern browsers/jsdom never reach this branch
  return Math.floor(Math.random() * 0xffffffff);
}

export function createPrng(seed?: number): Prng {
  let nextFn = makePrng(seed ?? randomSeed());
  return {
    next: () => nextFn(),
    int: (n: number) => nextFn(n),
    reset: (s?: number) => {
      nextFn = makePrng(s ?? randomSeed());
    },
  };
}
